import { useSelector } from 'react-redux';

export const useIsAuthUsed = () => {
    return useSelector((state) => {
        const { parameters } = state;
        const { getTokensData, getClientDataJws, adAuthUrl, isAuthZone } = parameters;

        return Boolean(isAuthZone || getTokensData || getClientDataJws || adAuthUrl);
    });
};
